<script setup lang="ts">
// TODO: find out why this is breaking in dev mode, and why we need to wrap in client-only?

const { state: notificationState, hasProgressBar, progressFraction, openNotificationTray, closeNotificationTray, isUploading, isDownloading, isCopying } = useNotificationTray()
const { state: alertState } = useAlerts()
const { isOffline } = useCache()

const erroring = computed(() => {
  for (const alert of Object.values(alertState.value.alerts))
    if (alert.type === "error-alert")
      return true
  return false
})

const progress = computed(() => hasProgressBar())
function progressStyle() {
  if (hasProgressBar())
    return px((1 - progressFraction()) * 24 * Math.PI)
  return px(0)
}
</script>

<template>
  <div class="tray-pill" :class="{ erroring }">
    <client-only>
      <dropdown
        v-model:active="notificationState.isOpen"
        anchor-x="left"
        anchor-y="bottom"
        flow-x="right"
        flow-y="down"
      >
        <template #default="{ active }">
          <nav-pill class="tray">
            <div class="pill-progress">
              <svg
                width="24"
                height="24"
                viewBox="-3 -3 30 30"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                style="transform:rotate(-90deg)"
              >
                <circle
                  r="12"
                  cx="12"
                  cy="12"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  :stroke-dashoffset="progressStyle()"
                  fill="transparent"
                  stroke-dasharray="75.39px"
                  class="pill-progress-circle"
                  :class="{ progress }"
                />
              </svg>
            </div>
            <div class="pill-inner" @click="active ? closeNotificationTray() : openNotificationTray()">
              <icon-action
                v-if="progress && isUploading"
                size="xs"
                type="arrow-up"
                class="in-progress"
              />
              <icon-action
                v-else-if="progress && isDownloading"
                size="xs"
                type="arrow-down"
                class="in-progress"
              />
              <icon-action
                v-else-if="progress && isCopying"
                size="xs"
                type="arrow-up"
                class="in-progress"
              />
              <icon-action
                v-else-if="isOffline()"
                size="xs"
                type="offline"
                class="offline"
              />
              <icon-action
                v-else
                size="xs"
                type="check"
                class="no-progress"
              />
            </div>
          </nav-pill>
        </template>
        <template #menu>
          <notification-tray-dropdown class="tray-dropdown" />
        </template>
      </dropdown>
    </client-only>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
.tray-pill
  app-region: no-drag
  @apply z-navigation-layer relative

.tray
  @apply aspect-square
  &:hover
    @apply bg-[#{$pill-bg-button-hover}]
  .pill-progress
    @apply absolute w-full h-full flex items-center justify-center
    .pill-progress-circle
      @apply stroke-[#{$global-bg-icon-secondary-alt}]
    .pill-progress-circle.progress
      @apply stroke-$global-blue-primary

.pill-inner
  @apply h-full w-full items-center justify-center flex
  @apply cursor-pointer z-1
  @apply text-$global-blue-primary
  @apply rounded-[#{$pill-btz-br-default}]
  .in-progress
    @apply text-$global-blue-primary
  .offline
    @apply text-$global-amber-primary
  .no-progress
    @apply text-[#{$global-bg-icon-secondary-alt}]

.tray-dropdown
  @apply my-2 w-[#{$menu-tray-w-default}]
</style>
